import AccordionHeader from './AccordionHeader';
import { AccordionHeaderProps, AccordionHeaderValueProps } from './types';

export type { AccordionHeaderProps, AccordionHeaderValueProps };
export default AccordionHeader;
